import { Audience } from '../audience/components/audience.model';

// Parses audiences_list results into client Audience objects (the shape the audience flyout takes).
// The whole row is kept, not a projection, so the flyout gets the filters and conditions it edits;
// rows missing a string id or name are dropped.
export function parseAudiences(content: unknown): Audience[] {
  const items: unknown[] = Array.isArray(content) ? content : [];
  const audiences: Audience[] = [];
  for (const item of items) {
    if (!item || typeof item !== 'object') {
      continue;
    }
    const row = item as Record<string, unknown>;
    if (typeof row['id'] === 'string' && typeof row['name'] === 'string') {
      audiences.push(item as Audience);
    }
  }
  return audiences;
}

// Union of several results, deduped by id (first occurrence wins).
export function mergeAudiences(contents: unknown[]): Audience[] {
  const byId = new Map<string, Audience>();
  for (const content of contents) {
    for (const audience of parseAudiences(content)) {
      if (audience.id && !byId.has(audience.id)) {
        byId.set(audience.id, audience);
      }
    }
  }
  return [...byId.values()];
}
